<template>
  <v-progress-circular
    :rotate="-90"
    :size="33"
    :width="2"
    :value="question_completion_percentage"
    :color="progressColour"
    :class="className"
  >
    {{ question_completion_percentage }}
  </v-progress-circular>
</template>

<script>
export default {
  name: 'AbfQuestionCompletionGauge',
  props: {
    question_completion_percentage: {
      type: Number,
      default: 0
    },
    className: {
      type: String,
      default: 'mr-1'
    }
  },
  computed: {
    progressColour() {
      let colour = 'red';
      if (this.question_completion_percentage === 100) {
        colour = 'accent';
      } else if (this.question_completion_percentage >= 50) {
        colour = 'orange darken-2';
      }
      return colour;
    }
  }
};
</script>

<style scoped></style>
